import { Component, OnInit } from '@angular/core';
import { Filter } from "../filter";
import { FilterGroupComponent } from "../../filter-group.component";
import { EnumerationService } from "@core/services/enumeration/enumeration.service";

@Component({
  selector: 'app-marital-status-filter',
  templateUrl: './marital-status-filter.component.html',
  styleUrls: ['./marital-status-filter.component.scss']
})
export class MaritalStatusFilterComponent extends Filter implements OnInit {

  maritalStatuses: any[];

  constructor(public filterGroup: FilterGroupComponent,
    private enumerationService: EnumerationService) {
    super(filterGroup);
  }

  ngOnInit() {
    this.enumerationService.getMaritalStatuses$()
      .subscribe(response => {
        this.maritalStatuses = response.body;
      });
  }

  updateOperator(operator: string): void {
    this.filterCondition.operator = operator;
    if (this.checkFilterValidity()) {
      this.setAsValid();
      this.filterGroup.applyFilters();
    } else {
      this.filterCondition.isValid = false;
    }
  }

  updateFilter(maritalStatus: any): void {
    if (maritalStatus !== null) {
      this.filterCondition.value = maritalStatus;
      this.setAsValid();
    } else {
      this.isValid = false;
    }
    this.filterGroup.applyFilters();
  }

  private checkFilterValidity(): boolean {
    return this.filterCondition.operator !== null &&
      this.filterCondition.operator !== '' &&
      this.filterCondition.value !== null &&
      this.filterCondition.value !== '';
  }

  getSummary(): string {
    if (this.filterCondition.value) {
      const operator = this.filterCondition.operator === 'is' ? 'is' : 'is not';
      const value = this.filterCondition.value.displayName;
      return `<div>Marital Status ${operator} <strong>${value}</strong></div>`;
    }
    return '';
  }

  getQuery(): any {
    if (this.filterCondition.value) {
      return { martialStatus: this.filterCondition.value.value, martialStatusMatch: this.filterCondition.operator === 'is' };
    }
    return null;
  }
}
